export const LOAD_ACTIONABLE_TASKS_SUCCESS = "LOAD_ACTIONABLE_TASKS_SUCCESS";

export const LOAD_ACTIONABLE_TASK_SUCCESS = "LOAD_ACTIONABLE_TASK_SUCCESS";

export const INSUFFICIENT_TASK_ACTIONED_SUCCESS = "INSUFFICIENT_TASK_ACTIONED_SUCCESS";

export const LOAD_ACTIONABLE_TASKS = "LOAD_ACTIONABLE_TASKS";
export const ACTION_INSUFFICIENT_INFORMATION_TASK = "ACTION_INSUFFICIENT_INFORMATION_TASK";
